import type { MessagePart } from 'tripPlanner/components/Chat/Message'

export function mergeConsecutiveTextParts(parts: Array<MessagePart>): Array<MessagePart> {
  const result: Array<MessagePart> = []

  for (const part of parts) {
    if (part.type === 'text') {
      const last = result[result.length - 1]
      if (last?.type === 'text') {
        result[result.length - 1] = { type: 'text', content: last.content + part.content }
      } else {
        result.push({ type: 'text', content: part.content })
      }
    } else {
      result.push(part)
    }
  }

  return result
}

export function getTextFromParts(parts: Array<MessagePart>): string {
  return parts
    .filter((p): p is Extract<MessagePart, { type: 'text' }> => p.type === 'text')
    .map((p) => p.content)
    .join('')
}

export function getTripPlanMarkdownFromParts(parts: Array<MessagePart>): string {
  const tripPlanPart = parts.find(
    (p): p is Extract<MessagePart, { type: 'trip_plan_content' }> => p.type === 'trip_plan_content',
  )
  return tripPlanPart?.content ?? ''
}
